import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { useCallback, useEffect } from 'react';
import createSyarahV2Fetcher from "@/common/fetchSyarahv2";
import useLocalStorage from "@hooks/useLocalStorage";
var LOCAL_STORAGE_KEY = 'event_tracking_v2';
var INTERVAL_IN_MS = 2000;
// Shared mutex map for coordination between hook and standalone functions
var mutexMap = {};
var _useLocalStorage = useLocalStorage(false),
  getLocalStorage = _useLocalStorage.getLocalStorage,
  setLocalStorage = _useLocalStorage.setLocalStorage;
// Standalone function implementation
function acquireMutex(_x) {
  return _acquireMutex.apply(this, arguments);
}
function _acquireMutex() {
  _acquireMutex = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(key) {
    var releaseFunc, waitForPrev, newPromise;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          waitForPrev = mutexMap[key] || Promise.resolve();
          newPromise = new Promise(function (resolve) {
            releaseFunc = resolve;
          });
          mutexMap[key] = newPromise;
          _context2.n = 1;
          return waitForPrev;
        case 1:
          return _context2.a(2, function () {
            releaseFunc();
            delete mutexMap[key];
          });
      }
    }, _callee2);
  }));
  return _acquireMutex.apply(this, arguments);
}
export function pushEventToQueue(_x2) {
  return _pushEventToQueue.apply(this, arguments);
}

// React Hook implementation
function _pushEventToQueue() {
  _pushEventToQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
    var release, eventsStr, events;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return acquireMutex(LOCAL_STORAGE_KEY);
        case 1:
          release = _context3.v;
          try {
            eventsStr = getLocalStorage(LOCAL_STORAGE_KEY);
            events = eventsStr ? JSON.parse(eventsStr) : [];
            events.push(event);
            setLocalStorage(LOCAL_STORAGE_KEY, JSON.stringify(events));
          } finally {
            release();
          }
        case 2:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _pushEventToQueue.apply(this, arguments);
}
export function useLocalStorageEventConsumer() {
  var processEvents = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var release, eventsStr, events, results, remainingEvents, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.n = 1;
          return acquireMutex(LOCAL_STORAGE_KEY);
        case 1:
          release = _context.v;
          _context.p = 2;
          eventsStr = getLocalStorage(LOCAL_STORAGE_KEY);
          events = eventsStr ? JSON.parse(eventsStr) : [];
          if (!(events.length === 0)) {
            _context.n = 3;
            break;
          }
          return _context.a(2);
        case 3:
          _context.n = 4;
          return Promise.allSettled(events.map(function (eventItem) {
            return createSyarahV2Fetcher({
              throwValidationException: false
            }).post("/log/freshwork", eventItem.params);
          }));
        case 4:
          results = _context.v;
          remainingEvents = events.filter(function (_, index) {
            return results[index].status !== 'fulfilled';
          });
          setLocalStorage(LOCAL_STORAGE_KEY, JSON.stringify(remainingEvents));
          _context.n = 6;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          console.error('Error processing events:', _t);
        case 6:
          _context.p = 6;
          release();
          return _context.f(6);
        case 7:
          return _context.a(2);
      }
    }, _callee, null, [[2, 5, 6, 7]]);
  })), [LOCAL_STORAGE_KEY]);
  useEffect(function () {
    var intervalId = setInterval(processEvents, INTERVAL_IN_MS);
    return function () {
      return clearInterval(intervalId);
    };
  }, [processEvents]);
}